export enum RoofStatusAPIResponse {
  Existing = 'existing',
  ExistingRaised = 'existingRaised',
  New = 'new',
  NewRaised = 'newRaised',
  NewComplete = 'newComplete',
  ExpediteReroof = 'expediteReroof',
  MidtermReplace = 'midtermReplace',
  MidtermRaised = 'midtermRaised',
  NotApplicable = 'notApplicable',
}
